import React, { FC } from 'react'

import { Navbar, useForTablet } from '@sketch/components'
import { ArtboardDetailInfoFragment } from '@sketch/gql-types'
import { ReactComponent as PlayIcon } from '@sketch/icons/play-20'
import { RouteParams, SketchHomeButton } from '@sketch/modules-common'
import { Zoom, ZoomProps, ZoomTypes } from 'components/Zoom'
import { Link, useParams } from 'react-router-dom'

import ArtboardPaginationControls from 'modules/shares/components/ArtboardPaginationControls'
import BackButton from 'modules/shares/components/BackButton'
import HeaderNavigation from 'modules/shares/components/HeaderNavigation'
import { Pagination } from 'modules/shares/types'
import { ShareWithoutVersion, useVersioning } from 'modules/versioning'

import { NavbarBackButtonItem, NavbarItem } from './ArtboardDetailHeader.styles'
import { useGridAndLayoutPropForZoomComponent } from '../../hooks'

const UntypedArtboardPaginationControls = ArtboardPaginationControls as any

type ArtboardDetailHeaderEmbeddedProps = {
  share: ShareWithoutVersion
  artboard: ArtboardDetailInfoFragment | undefined
  pagination?: Pagination
  showPrototypePlayButton: boolean
  onZoomChanged: ZoomProps['setZoom']
  currentZoom: ZoomTypes
}

export const ArtboardDetailHeaderEmbedded: FC<ArtboardDetailHeaderEmbeddedProps> = ({
  share,
  artboard,
  showPrototypePlayButton,
  pagination,
  currentZoom,
  onZoomChanged,
}) => {
  const { getPathname } = useVersioning()
  const { shareID } = useParams<RouteParams<'ARTBOARD_DETAIL'>>()

  const isTabletAndBigger = useForTablet()
  const showPagination = pagination && isTabletAndBigger

  const prototypePath = getPathname({
    routeKey: 'PROTOTYPE_PLAYER',
    routeParams: {
      shareID,
      currentArtboardUUID: artboard?.uuid!,
      prototypeArtboardUUID: artboard?.uuid!,
    },
  })

  const gridAndLayoutPropsForZoomComponent = useGridAndLayoutPropForZoomComponent()

  return (
    <Navbar>
      <Navbar.Section>
        <SketchHomeButton />

        <NavbarBackButtonItem>
          <BackButton />
        </NavbarBackButtonItem>

        <HeaderNavigation share={share} artboard={artboard} />
      </Navbar.Section>

      <Navbar.FixedWidthSection align="end">
        {showPrototypePlayButton && (
          <Link to={prototypePath} title="Play prototype">
            <Navbar.Button icon={PlayIcon} />
          </Link>
        )}

        {showPagination && (
          <NavbarItem>
            <UntypedArtboardPaginationControls
              current={pagination.current}
              total={pagination.total}
              showNumbers
            />
          </NavbarItem>
        )}

        <NavbarItem>
          <Zoom
            zoom={currentZoom}
            setZoom={onZoomChanged}
            gridAndLayout={gridAndLayoutPropsForZoomComponent}
          />
        </NavbarItem>
      </Navbar.FixedWidthSection>
    </Navbar>
  )
}
